
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExpiryNotificationService {
  private toastSubject = new BehaviorSubject<{ message: string; severity: string } | null>(null);
  toast$ = this.toastSubject.asObservable();

  showToast(message: string, severity: string ) {
    this.toastSubject.next({ message, severity });
  }

  clearToast() {
    this.toastSubject.next(null);
  }
}
